import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ClickarPath } from "@shared/clickar-constants";
import { TableData } from "@shared/model/auction.model";
import { MyLotFullDTO } from "@shared/model/showcase.model";
import { VehicleShowcaseDTO } from "@shared/model/vehicle.model";
import { ShowcaseService } from "@shared/services/showcase/showcase.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-my-lot",
	templateUrl: "./my-lot.component.html",
	styleUrl: "./my-lot.component.scss",
	standalone: false
})
export class MyLotComponent implements OnInit {
	protected Math = Math;
	tableData: TableData = {
		rowsOnPage: 10,
		orderBy: "dateCreate",
		sortOrder: "desc",
		offset: 30,
		limit: 0,
		col: 21
	};

	vehicles: VehicleShowcaseDTO[] = [];
	rowsOnPageSet = [10, 20, 30];
	selectall = false;
	myLotFull: MyLotFullDTO;
	message = " ";

	constructor(
		public utils: ClickarUtilsService,
		private showcaseService: ShowcaseService,
		public wcmService: WcmService,
		public location: Location,
		private router: Router
	) { }

	ngOnInit() {
		this.getMyLot();
	}

	getMyLot() {
		this.showcaseService.getMyLotUsingGET()
			.subscribe(value => {
				this.myLotFull = value;
				this.vehicles = value.myLotDTO.vehicles;
			});
	}

	selectAll() {
		this.selectall = !this.selectall;
		for (const v of this.vehicles) {
			v.selected = this.selectall;
		}
	}

	vehicleDetails(idVehicle: number) {
		this.router.navigate([
			`${ClickarPath.PRIVATE}/${ClickarPath.VEHICLE_MANAGEMENT}/${ClickarPath.VEHICLE_DETAILS}`,
			{ idVehicle }
		]);
	}

	removeSelected() {
		const ids = this.vehicles
			.filter(value => value.selected)
			.map(value => value.idVehicle);
		if (ids.length > 0) {
			this.showcaseService.removeToMyLotUsingDELETE(ids)
				.subscribe(() => {
					this.getMyLot();
				});
		}
	}

	bookLot() {
		this.showcaseService.bookMyLotUsingPATCH(this.message)
			.subscribe(() => {
				this.location.back();
			});
	}

	removeDisabled() { return !this.vehicles.some(value => value.selected); }

	selectLogo(element) {
		if (this.utils.isEmpty(element.appraisalCode)) {
			if (this.utils.isEmpty(element.idPrincipalPhoto)) {
				return this.wcmService.noPhotoUrl;
			} else {
				return this.utils.getImageUrl(element.idPrincipalPhoto);
			}
		} else {
			return element.imageUrl;
		}
	}

	selectRowMobile(event, i) {
		if (this.vehicles[i]) {
			this.vehicles[i].selected = event;
		}
	}
}